module.exports = __webpack_public_path__ + "static/media/logo2.58dd6b72.png";